export default "__VITE_ASSET__DypRdYAT__"